<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Finco",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Finco",
            items: [
                {
                text: "Partner Management",
                href: "/",
                },
                {
                text: "Finco",
                active: true,
                },
            ],
        
            fincoList:[],
            countryList:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },
        getFincoList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'finco/list')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.fincoList = response.data;
                    console.log(this.fincoList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        add_new_finco(e)
        {      
            if(this.finco_name != ''){
                e.preventDefault()
                const posting_ = { 
                    finco_name: this.finco_name,
                    country: this.country,
                };
                             
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'finco/create', posting_)
                .then(response => {
                    if (response) {
                        document.getElementById("add_new_finco").reset();
                        alert(response.data.msj);
                     
                        this.getFincoList();
                    }else{
                        this.ButtonSeen=false;
                        console.log('problem');
                    }
                });
            }else{
                e.preventDefault()
                alert('Please fill up the required fields.')
            }
        },

        //raw data----------------------------------------------------------

        get_country(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'finco/raw_data_country')
            .then(response => {
                if (response) {
                    this.countryList = response.data;
                    console.log(this.countryList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        //raw data----------------------------------------------------------
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
    },

    mounted() {
        this.getFincoList();
        this.get_country();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="d-flex justify-content-end mb-3">
            <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#fincoModal"  v-if="this.role == 1"><i class="ri-add-line align-middle me-1"></i> Add New FINCO</button> <br><br>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable class="table table-striped table-nowrap mb-0"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>No.</th>
                                            <th scope="col">Name</th>      
                                            <th scope="col">Country</th>      
                                            <th scope="col">Status</th>
                                            <th scope="col">Created Date</th>
                                            <th scope="col">Created By</th>
                                            <!--th scope="col">Action</th-->
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in fincoList" :key="index" class="content">
                                            <td>{{ index+1 }}</td>                               
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.country_name }}</td>
                                            <td v-if="item.status == 0"><span class="badge bg-success">Active</span></td>
                                            <td v-else><span class="badge bg-danger">Disabled</span></td>
                                            <td>{{ format_date(item.created_at) }}</td>                                          
                                            <td>{{ item.user_name }}</td>                                          
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-------------------------------------------------------------
         ADD FINCO MODAL
        <------------------------------------------------------------->

        <div class="modal fade" id="fincoModal" tabindex="-1" aria-labelledby="fincoModal">
            <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="fincoModaltitle">Add New FINCO</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>               
                </div>
                <hr class="my-1 text-muted">
                <div class="modal-body">
                    <form @submit="add_new_finco" id="add_new_finco">
                        <div class="row g-3">
                            <div class="col-xxl-12">
                                <div>
                                    <label for="finco_name" class="form-label">FINCO</label>
                                    <input type="text" v-model='finco_name' class="form-control" id="finco_name" placeholder="Enter FINCO Name" required/>
                                </div>
                            </div>
                            <div class="col-xxl-12">
                            <label>Country</label>
                            <select v-model="country" class="form-select mb-3" arial-label="Default select example" placeholder="Please Select Country" required>
                                <option value="">--- Select Country ---</option>
                                <option v-for="(item, index) in countryList" :key="index" :value="item.id" >
                                    {{ item.name }}
                                </option>
                            </select>
                            </div>
                            <hr class="my-1 text-muted">
                            
                            <div class="col-lg-12">
                                <div class="hstack gap-2 justify-content-end">
                                    <button type="button" class="btn btn-light"
                                        data-bs-dismiss="modal">Close</button>
                                    <button type="submit" class="btn btn-primary">Submit</button>
                                </div>
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </form>
                </div>
            </div>
        </div>
        </div>
        <!-- end of modal -->

    </Layout>
</template>